import { render, staticRenderFns } from "./ProductMobileRow.vue?vue&type=template&id=6cdda194&scoped=true"
import script from "./ProductMobileRow.vue?vue&type=script&lang=js"
export * from "./ProductMobileRow.vue?vue&type=script&lang=js"
import style0 from "./ProductMobileRow.vue?vue&type=style&index=0&id=6cdda194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdda194",
  null
  
)

export default component.exports